<template>
    <div class="brandDetails">
        <!--<div class="memberRuleNav">-->
            <!--<i @click="returnFn" class="iconfont iconzuojiantou"></i>-->
        <!--</div>-->
        <div class="scrollBox">
            <div class="scrollContent">
                <div class="branDetailsBox">
                    <div class="headBox">
                        <div class="imgBox" v-if="itemData.logoUrl">
                            <img class="imgStyle" :src="'/manager/fileserver/file/download?id='+itemData.logoUrl" />
                        </div>
                        <div class="headtitle">
                            <div class="headtitleItem">{{itemData.brandNa}}</div>
                            <div class="headtitleItem">{{itemData.floorId}}</div>
                            <div class="headtitleItem" v-if="itemData.linkman">{{itemData.linkman}}</div>
                            <div class="headtitleItem" v-if="itemData.telephone" @click="gotoPhone(itemData.telephone)">{{itemData.telephone}}
                                <i class="iconfont icondianhua"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="branDetailsVBox">
                    <div class="brandMar">
                        <div class="branTitel">
                            品牌简介
                            <i class="iconfont iconpinpai1"></i>
                        </div>
                        <img :src="'/manager/fileserver/file/download?id='+itemData.imgUrl" class="brief">
                        <div class="brandImgText" v-html="itemData.shortIntroduce"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "brandDetails",
        data(){
          return {
              itemData:''
          }
        },
        mounted() {
            document.title = "品牌详情"
            this.itemData = JSON.parse(this.$route.query.itemData)
            this.itemData.shortIntroduce = this.itemData.shortIntroduce.replace(/[\r\n]/g,"<br/>").replace(/\s/g,"&nbsp;")
        },
        methods:{
            // returnFn(){
            //     this.$router.go(-1)
            // }
        }
    }
</script>

<style lang="scss" scoped>
.brandDetails{
    position: relative;
    width: 100%;
    height: 100%;
    /*.memberRuleNav{*/
        /*width: 100%;*/
        /*height: 45px;*/
        /*background-color: #6cf;*/
        /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
        /*line-height: 45px;*/
    /*}*/
    /*.iconzuojiantou{*/
        /*font-size: 24px;*/
        /*color: #fff;*/
        /*margin-left: 4px;*/
        /*padding: 6px;*/
    /*}*/
    .brief{
        margin-top: 12px;
        width: 100%;
        height: 220px;
    }

    .scrollBox{
        position: absolute;
        /*top: 45px;*/
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollContent{
        width: 100%;
    }
    .branDetailsBox{
        margin-top: 1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
    }
    .headBox{
        width: 88%;
        height: 120px;
        display: flex;
        align-items: center;
    }
    .imgBox{
        width: 120px;
        height: 88px;
        border: 1px solid #f1f1f1;
    }
    .imgStyle{
        width: 100%;
        height: 100%;
    }
    .headtitle{
        width: 190px;
        height: 88px;
        margin-left: 10px;
    }
    .headtitleItem{
        font-size: 14px;
        color: #666;
        height: 22px;
        line-height: 22px;
    }
    .branDetailsVBox{
        margin-top: 8px;
        background-color: #fff;
    }
    .icondianhua{
        font-size: 14px;
        color: #66ccff;
        margin-left: 4px;
    }
    .branTitel{
        font-weight: 600;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
    }
    .brandMar{
        width: 90%;
        margin: auto;
        padding-bottom: 20px;
        color: #444;
    }
    .iconpinpai1{
        font-size: 14px;
        color: #888;
    }
    .brandImgText{
        width: 100%;
        height: auto;
        font-size: 14px;
        color: #888;
        margin-top: 17px;
        line-height: 23px;
        letter-spacing: 1px;
        font-family: "微软雅黑";
        padding-bottom: 25px;
        background-color: #fff;
    }
    .brandImgBox{
        width: 150px;
        height: 130px;
        border: 1px solid #dfdfdf;
        float: left;
        margin: 0 13px 0px 0;
    }
    .brandImgStyle{
        width: 100%;
        height: 100%;
    }
}
</style>
